import React, { createRef } from "react";
import ToggleLink from "../../../../dropdown/toggleLink";
import MenuContent from "../../../../dropdown/menuContent";
import { useLocation } from "react-router-dom";
import SmoothDropdown from "../../../../../../../components/controllers/shared/smoothDropdown/smoothDropdown";
import List, { ListProps } from "./elements/list";
import { useDisplayPlansData } from "hooks/data/useDisplayPlans";
import { useGlobalContext } from "../../../../../../../context/global/state";
import NoDemoLink from "components/controllers/shared/tooltip/noDemoLink";

const Dropdown: React.FC = () => {
	let ref = createRef<HTMLUListElement>();
	const location = useLocation();
	const { data } = useGlobalContext();
	const companyName = data.companyName;

	const category = location.pathname.includes("member")
		? "member"
		: "employer";
	const {
		filter: { selected },
	} = useDisplayPlansData(category);

	return (
		<SmoothDropdown id="dropdown-custom-my-accounts">
			<ToggleLink className="myAccountsActivator" bsRole="toggle">
				My Accounts
				<i
					className="fa fa-chevron-down util-margin-left-5"
					style={{
						fontSize: "10px",
						marginTop: "-4px",
						verticalAlign: "middle",
					}}
					aria-hidden="true"
				></i>
			</ToggleLink>

			<MenuContent
				additionalClasses="webdemoMyAccountsList"
				bsRole="menu"
			>
				<ul ref={ref} className="webdemoMyAccountContent">
					{selected.map((item) => {
						const listProps: ListProps = {
							item,
							companyName,
						};

						return (
							<List
								key={`plans-list-${category}-${item.id}`}
								{...listProps}
							/>
						);
					})}
				</ul>
				<div
					className="util-padding-20"
					style={{ display: "flex", justifyContent: "space-between" }}
				>
					<span>
						<NoDemoLink>
							{selected.length} Linked accounts
						</NoDemoLink>
					</span>
					<span>
						<NoDemoLink>Link a new account +</NoDemoLink>
					</span>
				</div>
			</MenuContent>
		</SmoothDropdown>
	);
};

export default Dropdown;
